import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-viewer-dialog',
  template: `
    <div class="modal-header">
      <span>{{ data.name || 'PDF' }}</span>
      <button class="close-btn" (click)="close()">×</button>
    </div>

    <div class="modal-body">
      <pdf-viewer
        *ngIf="pdfData"
        [src]="pdfData"
        [render-text]="true"
        [original-size]="false"
        style="width: 100%; height: 100%;">
      </pdf-viewer>

      <div *ngIf="!pdfData" class="pdf-fallback">
        Cargando PDF...
      </div>
    </div>

    <div class="modal-footer">
      <button class="download-btn" (click)="download()">⬇ Descargar PDF</button>
    </div>
  `,
  styles: [`
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      font-weight: 500;
      border-bottom: 1px solid #ddd;
      font-size: 17px;
    }

    .close-btn {
      cursor: pointer;
      border: none;
      background: transparent;
      font-size: 1.6rem;
      color: #48657bc4;
      border: 1px solid #cccccc33;
      background: #cccccc33;
    }

    .modal-body {
      height: 80vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    object {
      flex: 1;
    }

    .pdf-fallback {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 1rem;
      font-size: 1rem;
    }

    .modal-body {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 80vh;
      margin-bottom: 1rem;
    }

    .pdf-fallback {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 1rem;
      font-size: 1rem;
    }

    .modal-footer {
      display: flex;
      justify-content: center;
      padding: 0.5rem;
      border-top: 1px solid #ddd;
    }

    .download-btn {
      cursor: pointer;
      border: none;
      background: #4caf50;
      color: white;
      font-size: 0.9rem;
      padding: 0.4rem 0.8rem;
      border-radius: 4px;
    }

    .download-btn:hover {
      background: #45a049;
    }
  `],
  standalone: false
})
export class PdfViewerDialogComponent implements OnDestroy {
  pdfData: Uint8Array;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { source: Blob | Uint8Array | ArrayBuffer; name?: string },
    private dialogRef: MatDialogRef<PdfViewerDialogComponent>
  ) {
    if (data.source instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        this.pdfData = new Uint8Array(reader.result as ArrayBuffer);
      };
      reader.readAsArrayBuffer(data.source);
    } else if (data.source instanceof Uint8Array) {
      this.pdfData = data.source;
    } else {
      this.pdfData = new Uint8Array(data.source);
    }
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {

  }

  download(): void {
    let blob: Blob;

    if (this.data.source instanceof Blob) {
      blob =this.data.source ;
    } else if (this.data.source  instanceof Uint8Array) {
      const arrayBuffer = this.data.source .buffer;
      blob = new Blob([arrayBuffer as ArrayBuffer], { type: 'application/pdf' });
    } else {
      blob = new Blob([this.data.source  as ArrayBuffer], { type: 'application/pdf' });
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = this.data.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}



}
